import {ErrorMessage} from './types';

export const SET_ERROR_MESSAGE = 'ErrorPage/SET_ERROR_MESSAGE';
export const CLEAR_ERROR_MESSAGE = 'ErrorPage/CLEAR_ERROR_MESSAGE';

export function setErrorMessage(error: ErrorMessage) {
  return {
    type: SET_ERROR_MESSAGE,
    payload: {
      ...error,
    },
  };
}

export function clearErrorMessage() {
  return {
    type: CLEAR_ERROR_MESSAGE,
    payload: {},
  };
}
